import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { motion } from "framer-motion";
import { pushEvent } from "@/lib/gtm";

export default function Hero() {
  return (
    <section className="relative min-h-screen bg-[#0A0A0A] flex items-center overflow-hidden clip-diagonal-bottom">
      <img
        src="https://base44.app/api/apps/6a45c3b894a45b7fc0b9be49/files/mp/public/6a45c3b894a45b7fc0b9be49/401f4a06d_hero.webp"
        alt="Massive cable-stayed bridge span under dramatic sky"
        fetchpriority="high"
        decoding="async"
        className="absolute inset-0 w-full h-full object-cover opacity-50" />
      
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/70 to-transparent" />
      <div className="absolute top-0 right-0 h-full w-24 bg-[#E4001C]/80 hidden md:block" style={{ clipPath: "polygon(60% 0, 100% 0, 40% 100%, 0 100%)" }} />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative pt-32 pb-32 w-full">
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.8 }}>
          <p className="font-tech font-semibold uppercase tracking-[0.25em] text-[#FF4D5E] mb-5 text-sm sm:text-base">
            Building & Bridge Expansion Joint System PH
          </p>
          <h1 className="font-heading font-extrabold uppercase text-white text-5xl sm:text-7xl lg:text-8xl leading-[0.95] tracking-wide max-w-4xl">
            Engineered Strength.<br />
            <span className="text-[#E4001C]">Seamless</span> Movement.
          </h1>
          <p className="text-[#A8ADB4] text-lg max-w-2xl mt-8 leading-relaxed">Seisfra designs and supplies engineered movement joint systems for buildings, bridges, and infrastructure projects in the Philippines  precision-built for durability and long-term structural performance.



          </p>
          <div className="flex flex-wrap gap-4 mt-10">
            <Link to="/contact"
            onClick={() => pushEvent("request_quote_click", { location: "home_hero" })}
            className="inline-flex items-center gap-3 bg-[#E4001C] hover:bg-[#c00018] text-white font-tech font-semibold uppercase tracking-widest px-8 py-4 transition-all hover:gap-5">
              Request a Quote <ArrowRight className="w-5 h-5" />
            </Link>
            <Link to="/products"
            onClick={() => pushEvent("view_products_click", { location: "home_hero" })}
            className="inline-flex items-center gap-3 border border-white/40 hover:border-[#E4001C] hover:text-[#E4001C] text-white font-tech font-semibold uppercase tracking-widest px-8 py-4 transition-colors">
              View Systems
            </Link>
          </div>
        </motion.div>
      </div>
    </section>);

}